import "core-js/modules/es.regexp.exec.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import ioslogo from '../../assets/ioslogo.png';
import androidlogo from '../../assets/androidlogo.png';
import logo from '../../assets/logo.png';
import downtips from '../../assets/downtips.png';
export default {
  name: 'Download',
  data: function data() {
    return {
      ioslogo: ioslogo,
      androidlogo: androidlogo,
      logo: logo,
      iosUrl: 'https://apps.apple.com/app/id6757213671',
      androidUrl: 'https://app.facepopo.com/qipaoMobile/qipao.apk',
      downtips: downtips,
      showTips: false
    };
  },
  computed: {
    bgStyle: function bgStyle() {
      var url = require('../../assets/dowloadBg.png');
      return {
        backgroundImage: "url('".concat(url, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
    }
  },
  methods: {
    isWeChat: function isWeChat() {
      return /micromessenger/i.test(navigator.userAgent || '');
    },
    /**
     * iOS 下载点击处理
     * 在微信环境下显示提示，其他环境正常跳转到 App Store
     */
    onIosClick: function onIosClick(e) {
      if (this.isWeChat()) {
        e.preventDefault();
        showToast('请在浏览器中打开或复制链接到浏览器');
        this.showTips = true;
      }
      // 非微信环境允许正常跳转到 App Store
    },
    onAndroidClick: function onAndroidClick(e) {
      if (this.isWeChat()) {
        e.preventDefault();
        this.showTips = true;
      }
    }
  },
  mounted: function mounted() {
    if (this.isWeChat()) {
      this.showTips = true;
    }
  }
};